import React from 'react';

class Footer extends React.Component {
  render() {
    return false;
  }
}

export default Footer;
